export enum VmAction{
    start = 0,
    stop = 1,
    restart = 2
}